<script>
import SecurityService from '../../services/security';
import ConfigurationService from '../../services/configuration';

import Tree from 'primevue/tree';
import Button from 'primevue/button';

export default {
  components: { Tree, Button },
  data() {
    return {
      menuItems: [],
      enabledNodes: [],
      baseConfig: null,
      roles: [],
      body: {},
      collapsePermissionPanel: false,
      collapseMenuItemsPanel: false,
      selectedKey: null,
      manageMenuItemDialogVisible: false,
      newMenuItem: {
        roles: [],
      },
      newCategory: {
        children: [{
          roles: []
        }],
        roles: [],
      },
      addMenuItemFormDialogVisible: false,
      addCategoryFormDialogVisible: false,
      addMenuItemMode: 0,
    }
  },
  computed: {
    uiPermissions() {
      return this.$store.getters['security/uiPermissions'];
    }
  },
  watch: {
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'menu_configuration.page_title');
    let data = {
      q: JSON.stringify({
        name: "SmartSim.WebAppNavigation",
      })
    }
    ConfigurationService.get(data, async (response) => {
      if(response.success && response.data.data[0]){
        const [{value, ...baseConfig}] = response.data.data
        this.baseConfig = baseConfig;
        this.menuItems = await Promise.all(value.map(async(item, index) => await this.mapMenuBranch(item, index)));
      }
    })
    SecurityService.getRoles({}, ({data, success}) => {
      if(success){
        this.roles = data.map((item) => item.name);
      }
    });
  },
  methods: {
    async mapMenuBranch(branch, key = 0) {
      const {text: label, items: children, name, ...keysBranch} = branch;
      const subItems = {label, children: Array.isArray(children) ? await Promise.all(children.map(async(item, index) => await this.mapMenuBranch(item, `${key}-${index}`))) : [], key, name, ...keysBranch};
      !subItems.children.length && delete subItems.children;
      return subItems;
    },
    onChange(event, node) {
        this.menuItems[node] = event.value;
    },
    async submitChanges(){
      await this.prepareBody();
      ConfigurationService.update(this.body, ({success, data}) => {
        if (success){
          this.baseConfig.__v = data.__v;
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        } else {
          this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    async prepareBody(){
      this.body = {
        ...this.baseConfig,
        value: (await this.revertMenu())
      }
    },
    async revertMenu(){
      return await Promise.all(this.menuItems.map(async(item) => await this.revertMapMenuBranch(item)));
    },
    async revertMapMenuBranch(branch) {
      const {label: text, children: items, key, ...keysBranch} = branch;
      const subItems = {text, items:Array.isArray(items) ? await Promise.all(items.map(async(item) => await this.revertMapMenuBranch(item))) : [], ...keysBranch};
      !subItems.items.length && delete subItems.items;
      return subItems;
    },
    deleteMenuItem(){
      this.$confirm.require({
        message: this.$t('messages.delete'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {

        },
        reject: () => {
          this.$confirm.close();
        }
      });
    },
    addCategory(){
      const selectedItem = Object.keys(this.selectedKey)[0].split('-')[0];
      this.menuItems.splice(Number(selectedItem) + 1, 0, this.newCategory);
    },
    addMenuItem(){
      const selectedItem = Object.keys(this.selectedKey)[0];

      if (this.addMenuItemMode === 'Inside selected item'){
        if(selectedItem.split('-').length === 1){
          this.menuItems[selectedItem].children.push(this.newMenuItem);
        } else {
          let subItems = selectedItem.split('-');
          let currentItem = this.menuItems[subItems[0]];

          for(let i = 1; i < subItems.length; i++){
            currentItem = currentItem.children[subItems[i]]
          }
          currentItem.children = [...(currentItem.children || []), this.newMenuItem]
        }
      } else if (this.addMenuItemMode === 'After selected item'){
        if(selectedItem.split('-').length !== 1){
          let subItems = selectedItem.split('-');
          let currentItem = this.menuItems[subItems[0]];

          for(let i = 0; i < subItems.length -1; i++){
            if (i === 0) continue;
            currentItem = currentItem.children[subItems[i]]
          }
          currentItem.children.splice(Number(subItems.slice(-1)[0]) + 1, 0, this.newMenuItem);
        }
      }
      // this.submitChanges();
    }
  }
}

</script>

<template>
  <main>
    <Dialog :header="$t('addCategoryAfterItem')" v-model:visible="addCategoryFormDialogVisible" :style="{width: '40vw'}" :modal="true">
      <Button :label="$t('btn.confirm')" icon="pi pi-check" class="p-button-outlined mb-3" @click="addCategory" :disabled="!uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
      <label class="block mt-2">{{ 'Label '}}</label>
      <InputText v-model="this.newCategory.label" class="w-full"/>
      <label class="block mt-2">{{ 'Name '}}</label>
      <InputText v-model="this.newCategory.name" class="w-full"/>
      <label class="block mt-2">{{ 'Icon '}}</label>
      <InputText v-model="this.newCategory.icon" class="w-full"/>
      <label class="block mt-2">{{ 'First menu item label'}}</label>
      <InputText v-model="this.newCategory.children[0].label" class="w-full"/>
      <label class="block mt-2">{{ 'First menu item name'}}</label>
      <InputText v-model="this.newCategory.children[0].name" class="w-full"/>
      <label class="block mt-2">{{ 'First menu item link'}}</label>
      <InputText v-model="this.newCategory.children[0].link" class="w-full"/>
      <label class="block mt-2">{{ 'First menu item icon'}}</label>
      <InputText v-model="this.newCategory.children[0].icon" class="w-full"/>
    </Dialog>
    <Dialog :header="$t('addMenuItem')" v-model:visible="addMenuItemFormDialogVisible" :style="{width: '40vw'}" :modal="true">
      <Button :label="$t('btn.confirm')" icon="pi pi-check" class="p-button-outlined mb-3" @click="addMenuItem" :disabled="!addMenuItemMode || !uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
      <Dropdown v-model="addMenuItemMode" :options="['Inside selected item', 'After selected item']" class="w-full"/>
      <label class="block mt-2">{{ 'Label '}}</label>
      <InputText v-model="this.newMenuItem.label" class="w-full"/>
      <label class="block mt-2">{{ 'Name '}}</label>
      <InputText v-model="this.newMenuItem.name" class="w-full"/>
      <label class="block mt-2">{{ 'Link '}}</label>
      <InputText v-model="this.newMenuItem.link" class="w-full"/>
      <label class="block mt-2">{{ 'Icon '}}</label>
      <InputText v-model="this.newMenuItem.icon" class="w-full"/>
    </Dialog>
    <Dialog :header="$t('manageMenuItem')" v-model:visible="manageMenuItemDialogVisible" :style="{width: '50vw'}" :modal="true">
      <p>{{ 'Choose item to do an operation' }}</p>
      <Button :label="$t('btn.addCategoryAfterItem')" icon="pi pi-plus" class="p-button-outlined ml-3 mb-3" @click="addCategoryFormDialogVisible = true" :disabled="!this.selectedKey || !uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
      <Button :label="$t('btn.addMenuItem')" icon="pi pi-plus" class="p-button-outlined ml-3 mb-3" @click="addMenuItemFormDialogVisible = true" :disabled="!this.selectedKey || !uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
      <Button :label="$t('btn.delete')" icon="pi pi-plus" class="p-button-outlined ml-3 mb-3" @click="deleteMenuItem" :disabled="!this.selectedKey || !uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
      <Tree :value="menuItems" v-model:selectionKeys="selectedKey" selectionMode="single">
        <template #default="slotProps">
          <b class="block">{{$t(slotProps.node.label)}}</b>
        </template>
      </Tree>
    </Dialog>
    <div class="m-5">
      <div class="grid">
        <div class="col-12">
          <Panel :header="$t('menu_configuration.menuItems')" :toggleable="true" v-model:collapsed='collapseMenuItemsPanel'>
            <Button :label="$t('btn.save')" icon="pi pi-check" class="p-button-outlined mb-3" @click="submitChanges" :disabled="!uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
            <Button :label="$t('btn.manage')" icon="pi pi-plus" class="p-button-outlined ml-3 mb-3" @click="manageMenuItemDialogVisible = true" :disabled="!uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
            <Tree :value="menuItems">
              <template #default="slotProps">
                <b class="block">{{$t(slotProps.node.label)}}</b>
                <div class="grid">
                  <template v-if="slotProps.node.label">
                    <div class="col-12 lg:col-4">
                      <label class="block mt-2">{{ 'Label '}}</label>
                      <InputText v-model="slotProps.node.label" class="w-full"/>
                    </div>
                  </template>
                  <template v-if="slotProps.node.link">
                    <div class="col-12 lg:col-4">
                      <label class="block mt-2">{{ 'Link '}}</label>
                      <InputText v-model="slotProps.node.link" class="w-full"/>
                    </div>
                  </template>
                  <template v-if="slotProps.node.name">
                    <div class="col-12 lg:col-4">
                      <label class="block mt-2">{{ 'Name '}}</label>
                      <InputText v-model="slotProps.node.name" class="w-full"/>
                    </div>
                  </template>
                  <template v-if="slotProps.node.icon">
                    <div class="col-12 lg:col-4">
                      <label class="block mt-2">{{ 'Icon '}}</label>
                      <InputText v-model="slotProps.node.icon" class="w-full"/>
                    </div>
                  </template>
                </div>
              </template>
            </Tree>
          </Panel>
        </div>
        <div class="col-12">
          <Panel :header="$t('menu_configuration.permissions')" :toggleable="true" v-model:collapsed='collapsePermissionPanel'>
            <Button :label="$t('btn.save')" icon="pi pi-check" class="p-button-outlined mb-3" @click="submitChanges" :disabled="!uiPermissions('menuUserRolesSaveButton').isEnabled" v-if="!uiPermissions('menuUserRolesSaveButton').isHidden"/>
            <Tree :value="menuItems">
              <template #default="slotProps">
                <b class="block">{{$t(slotProps.node.label)}}</b>
                <MultiSelect @change="onChange($event, slotProps.node.label)" v-model="slotProps.node.roles" :options="roles" display="chip" inputClass="w-full"/>
              </template>
            </Tree>
          </Panel>
        </div>
      </div>
    </div>
  </main>
</template>

<style lang="scss">

.p-multiselect  {
  width: 100%;
}

.p-treenode-label {
  width: 90%;
}

.p-multiselect-label {
  overflow: auto;
  text-overflow: unset;
}
</style>
